// extracted by mini-css-extract-plugin
export default {"root":"Overlay_root__CGYDx","rootIsOpened":"Overlay_rootIsOpened__50-KI"};